import React from 'react';
import Select from 'react-select';

type Props = {
  values: any;
  options: any;
  onChange: (e: any) => void;
};

const OPEN_STATUSES = ['new', 'active', 'reopened'];
const CLOSE_STATUSES = ['fixed', 'ignored'];

const colourStyles = {
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white'
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
  menu: (base) => ({
    ...base,
    width: 'max-content',
    minWidth: '100%',
  }),
};

function StatusMultiSelect({ values, options, onChange }: Props) {
  const handleOnChange = (e) => {
    const haveValidSelection = e?.length > 0;
    const isAllPreSelected =
      values.value === '' ||
      (values?.filter && values.filter((x) => x.value === '').length > 0);
    const allOption = e.filter((x) => x.value === '');
    const isAllSelected = allOption !== undefined && allOption.length > 0;
    const optionsExcludingAll = e.filter((x) => x.value !== '');

    // console.log({
    //   msg: 'handleOnChange',
    //   e,
    //   values,
    //   haveValidSelection,
    //   isAllPreSelected,
    //   allOption,
    //   optionsExcludingAll
    // });

    //  remove all option if some other option is selected
    if (haveValidSelection && isAllPreSelected) {
      onChange(optionsExcludingAll);
    }
    // else if all is now selected, and we have other options already selected
    else if (haveValidSelection && !isAllPreSelected && isAllSelected) {
      onChange(allOption);
    } else onChange(e);
  };

  return (
    <div>
      <Select
        closeMenuOnSelect={false}
        isMulti
        // searchable
        isClearable={false}
        hideSelectedOptions={false}
        options={options}
        onChange={handleOnChange}
        value={values}
        components={{ MultiValue }}
        styles={colourStyles}
      />
    </div>
  );
}

export default StatusMultiSelect;

const MoreSelectedBadge = ({ items }) => {
  const style = {
    marginLeft: 'auto',
    background: '#0e74bc',
    color: 'white',
    borderRadius: '4px',
    fontFamily: 'Open Sans',
    fontSize: '11px',
    padding: '3px 7px',
    order: 99,
  };

  const title = items.join(', ');
  const length = items.length;
  const label = `${length}`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};

const SelectedItem = ({ title }) => {
  const style = {
    marginRight: 'auto',
    color: '#222a42',
    padding: '3px',
    // order: 99
  };

  return <div style={style}>{title}</div>;
};

const MultiValue = ({ index, getValue, ...props }) => {
  const values = getValue();
  const maxToShow = 1;
  const overflow = values.map((x) => x.label);
  const actualLabel = values[index].label.trim();
  const selectedItemLabel =
    actualLabel.length < 12 ? actualLabel : `${actualLabel.substring(0, 9)}...`;

  // check if all open statuses are selected
  let labelToShow = values.length <= 1 ? selectedItemLabel : 'Multiple';
  if (index < maxToShow) {
    if (
      values?.length > maxToShow &&
      values?.length === OPEN_STATUSES.length &&
      OPEN_STATUSES.includes(values[0].value) &&
      OPEN_STATUSES.includes(values[1].value) &&
      OPEN_STATUSES.includes(values[2].value)
    ) {
      labelToShow = 'All Open';
    } else if (
      values?.length > maxToShow &&
      values?.length === CLOSE_STATUSES.length &&
      CLOSE_STATUSES.includes(values[0].value) &&
      CLOSE_STATUSES.includes(values[1].value)
    ) {
      labelToShow = 'All Closed';
    }
  }
  return index < maxToShow ? (
    <SelectedItem title={labelToShow} />
  ) : index === maxToShow ? (
    <MoreSelectedBadge items={overflow} />
  ) : null;
};
